module.exports = __webpack_public_path__ + "static/scroodles-hero-image-3a72351cb45e8bb33057d410bc5a625d.jpg";